<template>
  <div class="sponsor-wrapper">
     <h2 style="margin-bottom:10px; text-align:left;font-family:'prohibition'; color:#999;">Sponsors & Messages</h2>
      <div class="get-started-container sponsors">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="Week 1" name="one">
            <sponsor-form :week="1"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 2" name="two">
            <sponsor-form :week="2"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 3" name="three">
            <sponsor-form :week="3"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 4" name="four">
            <sponsor-form :week="4"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 5" name="five">
            <sponsor-form :week="5"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 6" name="six">
            <sponsor-form :week="6"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 7" name="seven">
            <sponsor-form :week="7"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 8" name="eight">
            <sponsor-form :week="8"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 9" name="nine">
            <sponsor-form :week="9"></sponsor-form>
          </el-tab-pane>
          <el-tab-pane label="Week 10" name="ten">
            <sponsor-form :week="10"></sponsor-form>
          </el-tab-pane>
        </el-tabs>
      </div>
  </div>
</template>

<script>
import SponsorForm from './form';
export default {
  name: 'start',
  components:{ SponsorForm},
  data () {
    return {
       activeName: 'one',
      checked:false,
      plans:[false, false, false],
      form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        basicVisible:false,
        advancedVisible:false,
        oneVisible:false,
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    handleClick:function(){

    },
    selectPlan(){

    },
    expandAdvanced:function(){

    },
    expandBasic:function(){

    },
    expandOneOnOne:function(){

    },
    onSubmit:function(){
      this.$router.push('/dashboard/prestage');
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onUploadClicked:function openPicker() {
        window.fsClient.pick({
          fromSources:["local_file_system","imagesearch","facebook","instagram","dropbox"]
        }).then(function(response) {
          // declare this function to handle response
          handleFilestack(response);
        });
    }
  }
}
</script>

<style>
.sponsor-wrapper{

  display:block;
  box-sizing:border-box;
}



.get-started-container.sponsors{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  text-align: left;
  padding: 10px 20px;
}
.get-started-container.sponsors form {
  max-width: 800px;
  margin:30px auto;
}
.get-started-container h1 {
  width: 100%;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
  font-family: prohibition;
  text-align: center;
  font-size: 30px;
  box-sizing: border-box;
}
.get-started-container.sponsors label {
  margin-bottom:0px;
  height:34px;
}
.get-started-container .el_select {
  width: 100%;
}
.get-started-container a{
  color: #d7347d;
}
.get-started-container p{
  text-align: center;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.el-input-group__append{
  width: 40px;
}
.get-started-btn {
  width: 100%;
}
.get-started-container .el-card{
  margin-bottom: 10px;
  position: relative;
  padding-left: 30px;
}
.get-started-container .el-card .el-card__body{
 padding: 10px 30px 10px 10px;
 line-height: 20px
}
.get-started-container .el-card .indicator {
  position: absolute;
  left:12px;
  top:12px;
  width: 16px;
  height: 16px;
  border-radius: 20px;
  border:1px solid #EEE;
  background-color: #FAFAFA;
}
.get-started-container .el-card span{
  position: absolute;
  top:10px;
  right:20px;
  font-weight: bold;
  font-size: 18px;
  color: #999;
}
.get-started-container .el-card {
  border:1px solid #EEE;
  border-radius: 4px;

}

</style>
